import { InlineLoading } from "@carbon/react";
import { useWebComponent } from "@flaminem/utils";
import React from "react";
import { useLocation } from "react-router-dom";

import InlineError from "src/components/Errors/InlineError.tsx";
import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { useLocale, useT } from "src/internationalization";

const FlaminemReporting: React.FC = () => {
  const { isLoaded, loading, error } = useWebComponent("/wc/reporting/flaminem-reporting.umd.js", [
    "/react.production.min.js",
    "/react-dom.production.min.js",
  ]);
  const location = useLocation();
  const { locale } = useLocale();
  const t = useT();

  return (
    <PageStack>
      <PageHeader className="mb-5">Reporting</PageHeader>
      {loading && <InlineLoading />}
      {!loading && customElements.get("flaminem-reporting") && isLoaded ? (
        <flaminem-reporting auth-mode="bearer" key={location.pathname} language-locale={locale} />
      ) : null}
      {!loading && error && (
        <InlineError
          message={t("error.fetch.item.mf.reporting.message")}
          title={""}
          type={"Error"}
        />
      )}
    </PageStack>
  );
};

export default FlaminemReporting;
